import { useNavigate, useParams } from 'react-router-dom';
import { useTableManagement, useTable } from '../../hooks/useTableManagement';
import { TableForm } from '../../components/admin/TableForm';
import './TableFormPage.css';

export function TableFormPage() {
  const navigate = useNavigate();
  const { tableId } = useParams<{ tableId: string }>();
  const isEditing = !!tableId;

  const { createTable, updateTable } = useTableManagement();
  const { data: table, isLoading } = useTable(tableId || '');

  const handleSubmit = async (data: { name: string; location?: string }) => {
    if (isEditing && tableId) {
      await updateTable({ tableId, payload: data });
    } else {
      await createTable(data);
    }
    navigate('/admin/tables');
  };

  const handleCancel = () => {
    navigate('/admin/tables');
  };

  if (isEditing && isLoading) {
    return (
      <div className="table-form-page">
        <div className="table-form-page__loading">Carregando...</div>
      </div>
    );
  }

  return (
    <div className="table-form-page">
      <div className="table-form-page__header">
        <h1 className="table-form-page__title">
          {isEditing ? 'Editar Mesa' : 'Nova Mesa'}
        </h1>
        <p className="table-form-page__subtitle">
          {isEditing
            ? 'Atualize as informações da mesa'
            : 'Cadastre uma nova mesa no sistema'}
        </p>
      </div>

      <div className="table-form-page__content">
        <TableForm
          initialData={table ? { name: table.name, location: table.location } : undefined}
          onSubmit={handleSubmit}
          onCancel={handleCancel}
          submitLabel={isEditing ? 'Atualizar' : 'Cadastrar'}
        />
      </div>
    </div>
  );
}
